import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import ForumIcon from '@mui/icons-material/Forum';

import api from '../../api';
import { COMMUNITY_FORUM } from '../../utils/constants/general';
import { FooterContainer, ContactIcon } from './styles';
import Link from '../../components/Link/Link';

const Footer = () => {
	const { t } = useTranslation();
	const [appVersion, setAppVersion] = useState(0);

	useEffect(() => {
		api.getAppVersion().then(data => {
			setAppVersion(data);
		});
	}, []);

	return (
		<FooterContainer>
			<Box
				display="flex"
				justifyContent="center"
				order={{
					xs: 2,
					sm: 1,
					md: 4,
					lg: 2,
					xl: 2
				}}>
				<ContactIcon>
					<ForumIcon fontSize="small" />
				</ContactIcon>

				<Typography variant="subtitle1" mr={2}>
					<Link variant="subtitle1" href={COMMUNITY_FORUM.url} target="_blank" underline="none">
						{t('general.communityForum')}
					</Link>
				</Typography>

				<Typography variant="subtitle1" mr={2}>
					|
				</Typography>

				<Typography variant="subtitle1">{appVersion + ' Beta'}</Typography>
			</Box>
		</FooterContainer>
	);
};

export default Footer;
